export const connect = {
  pracAvatarAlt: "Avatar for {{pracName}}",
  header: {
    productName: "Connect",
    beta: "Beta",
  },
  pageHead: {
    backToProfile: "Back to profile",
    eyebrow: "Almost there",
    title: "Create your account",
  },
  form: {
    alreadyHaveAnAccount: "Already have an account?",
    submitError: "Something went wrong. Please try again.",
  },
  checkEmail: {
    body: "We sent a link to <emailText>{{email}}</emailText> to confirm your email address and finish your request.",
    spamHint: "Didn't get the email? Check your spam folder.",
  },
  practitionerCard: {
    requestingAppointmentWith: "Requesting an appointment with",
    typeAndLocation: "{{practitionerType}} · {{location}}",
    firstVisit: "First visit",
    subsequentVisit: "Subsequent visit",
    visitPriceAndDuration: "{{price}} · {{durationMinutes}} min",
    freeVisitDuration: "Free {{durationMinutes}}-min",
  },
  nextSteps: {
    title: "What happens next",
    selectTimeslot: "Select a timeslot on {{pracFirstName}}'s agenda",
    requestGoesToOffice: "Your request goes straight to {{pracFirstName}}'s office.",
    accountUnlocksStorefront:
      "Meanwhile, your account unlocks {{pracFirstName}}'s storefront of professional-grade supplements.",
  },
} as const;
